// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type EntityPageUpdateLogoMutationVariables = Types.Exact<{
  id: Types.Scalars['SlugOrID']['input'];
  logoUploadId?: Types.InputMaybe<Types.Scalars['UploadId']['input']>;
  originalLogoUploadId?: Types.InputMaybe<Types.Scalars['UploadId']['input']>;
}>;

export type EntityPageUpdateLogoMutation = {
  __typename?: 'Mutation';
  entityPageUpdateLogo?: {
    __typename?: 'EntityPageMutationResult';
    error?: {
      __typename?: 'EntityPagesMutationError';
      errorType: string;
      errorCode: number;
    } | null;
  } | null;
};

export const EntityPageUpdateLogoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EntityPageUpdateLogo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SlugOrID' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'logoUploadId' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UploadId' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'originalLogoUploadId' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UploadId' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPageUpdateLogo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'entityPageId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'logoUploadId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'logoUploadId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'originalLogoUploadId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'originalLogoUploadId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errorType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errorCode' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EntityPageUpdateLogoMutation,
  EntityPageUpdateLogoMutationVariables
>;
